import { Box, Checkbox, IconButton } from "@mui/material";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckIcon from "@mui/icons-material/Check";
import { FileField, RequestFile } from "models/interfaces";
import { useState } from "react";
import {
  updateFieldInSignRequest,
  updateFieldOfSelectedFile,
} from "redux/appSlice";
import { fieldColorFor } from "screens/SignRequest/SignRequestHelper";
import { emitFieldCommit } from "screens/SignRequest/ParticipantScreen/ParticipantScreenService";

const CheckBoxField = ({
  field,
  dispatch,
  selectedFile,
  width,
  height,
  isMobile,
}: {
  field: FileField;
  dispatch: Function;
  selectedFile: RequestFile;
  width: number;
  height: number;
  isMobile?: boolean;
}) => {
  const rawValue = field.value as unknown;

  const isChecked = rawValue === true || rawValue === "true";

  const handleOnChange = (e: any) => {
    const newValue = !isChecked;
    dispatch(updateFieldOfSelectedFile({ id: field.id, value: newValue }));
    dispatch(updateFieldInSignRequest({ id: field.id, value: newValue }));
    emitFieldCommit();
  };

  const size = isMobile ? Math.max(height, 12) : height;
  const iconSize = isMobile ? size : height - 4;

  return (
    <Box
      className="checkbox-field"
      onTouchEnd={(e: any) => {
        e.preventDefault();
        e.stopPropagation();
        handleOnChange(e);
      }}
      onClick={(e: any) => {
        e.preventDefault();
        e.stopPropagation();
        handleOnChange(e);
      }}
      onMouseDown={(e) => e.stopPropagation()}
      sx={{
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: height,
        height: height,
      }}
    >
      {isChecked ? (
        <CheckIcon
          sx={{
            fontSize: iconSize,
            color: "#ffffff",
            backgroundColor: fieldColorFor(field.signerIndex),
          }}
        />
      ) : (
        <></>
      )}
    </Box>
  );
};

export default CheckBoxField;
